import { BIM360AttributeOption } from './BIM360AttributeOption';

export class BIM360IssueAttributeDefinition 
{
    public id: string = '';
    public description: string = '';
    public title: string = '';
    public options: BIM360AttributeOption[] = [];
    public containerId: string = '';
    public permittedActions: string[] = [];
    public permittedAttributes: string[] = [];
    public dataType: string = '';
    public static fromAutodeskJSON(json: any): BIM360IssueAttributeDefinition
    {
        let issueAttrDef = new BIM360IssueAttributeDefinition();
        issueAttrDef.id = json.id;
        issueAttrDef.description = json.description;
        issueAttrDef.title = json.title;
        issueAttrDef.containerId = json.containerId;
        issueAttrDef.permittedActions = json.permittedActions;
        issueAttrDef.permittedAttributes = json.permittedAttributes;
        let attrOptions = json.metadata?.list?.options;
        if(attrOptions){ attrOptions.map(o => BIM360AttributeOption.fromAutodeskJSON(o)) };
        issueAttrDef.options = attrOptions;
        issueAttrDef.dataType = json.dataType;
        return issueAttrDef;
    }
}
